import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode"; // ✅ Import jwtDecode to decode token
import CONFIG from "../config";
import { usePatient } from "./PatientContext"; // ✅ Import PatientContext

const AuthContext = createContext({ auth: null, setAuth: () => { } });

export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(null);
  const { setDoctorInfo, doctorInfo, token, setToken } = usePatient(); // ✅ Access setDoctorInfo from PatientContext
  const navigate = useNavigate();
  const baseURL = CONFIG.BASE_URL;

  /**
   * 🔹 Verify Token on App Load
   * Ensures user remains logged in after refresh.
   */
  useEffect(() => {
    verifyTokenAndRedirect();
  }, []);

  const verifyTokenAndRedirect = () => {
//    const token = localStorage.getItem("authToken");

    if (!token) {
      console.warn("❌ No auth token found. Redirecting to login.");
      //      window.location.href = "/check";
      navigate("/");
      //return;
    }

    try {
      const decoded = jwtDecode(token);
      const isExpired = decoded.exp * 1000 < Date.now();

      if (isExpired) {
        console.warn("❌ Token has expired. Redirecting to login.");
        setAuth(null);
        setDoctorInfo({ MANDALI_ID: null, CLINIC_ID: null, MANDALI_ROLE: null });
        //        window.location.href = "/check";
        //        return;
        navigate("/");
      }

      console.log("✅ Token is valid.");
      if (!auth) {
        setAuth(decoded.userData);
      }
      if (!doctorInfo) {
        setDoctorInfo({
          MANDALI_ID: decoded.userData.MANDALI_ID,
          CLINIC_ID: decoded.userData.CLINIC_ID,
          MANDALI_ROLE: decoded.userData.MANDALI_ROLE,
        })
      };


    } catch (error) {
      console.error("❌ Invalid token format. Redirecting to login.", error);
      //window.location.href = "/check";
      navigate("/");
    }
  };



  // /**
  //  * 🔹 Handle User Login
  //  * - Authenticates user and stores session data
  //  * - Extracts `DOCTOR_ID` & `CLINIC_ID` from token
  //  */
  // const login = async (credentials) => {
  //   try {
  //     const response = await axios.post(`${baseURL}/mandali/check`, credentials);
  //     if (response.data.token) {
  //       localStorage.setItem("authToken", response.data.token);
  //       setToken(response.data.token);
  //       verifyTokenAndRedirect(); // ✅ Automatically extracts user data
  //       navigate("/patientlist"); // ✅ Redirect to patient list after login
  //     }
  //     return response.data;
  //   } catch (error) {
  //     console.error("Login failed:", error);
  //     return { success: false, error: error.response?.data?.message || "Login error" };
  //   }
  // };

  /**
   * 🔹 Handle User Logout
   * - Clears session data and resets state
   */
  const logout = () => {
    localStorage.removeItem("authToken");
    setToken(null);
    setAuth(null);
    setDoctorInfo({ MANDALI_ID: null, CLINIC_ID: null, MANDALI_ROLE: null });
    navigate("/");
  };


  // /**
  //  * 🔹 Check User Authorization for a Specific Role
  //  * @param {Array} allowedRoles - Roles that are allowed
  //  * @returns {Boolean} - Whether the user has access
  //  */
  // const checkAuthorization = (allowedRoles) => {
  //   if (!auth || !auth.role) return false;
  //   return allowedRoles.includes(auth.role);
  // };

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
//        login,
        logout,
 //       checkAuthorization,
        verifyTokenAndRedirect,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
